// extracted by mini-css-extract-plugin
export default {"contentStyle":"ArchiveCampaignModal_contentStyle__08kJw","container":"ArchiveCampaignModal_container__+eTty","footer":"ArchiveCampaignModal_footer__L3zXI"};